// @vendors
import { Suspense } from 'react'
import { Provider } from '../context/appContext';
import esEs from 'antd/lib/locale/es_ES'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';

// @components
import Header from 'components/header'
import Page from 'components/page'
import ValidationError from 'components/validation-error';

// @pages
import Quotation from './quotation'

// @components
import Subheader from 'components/subheader'
import Footer from 'components/footer'
import { useFetchData } from '../hooks/useFetchData';


// @styles
import './styles.scss'
import Loading from 'components/loading';
import NotFound from './not-found';
import LoadingProcedure from 'components/loading-procedure';

// constant
const NOT_FOUND_404_ACTIVE = false

export default function Routes() {
    const context = useFetchData();
    TagManager.initialize({
        gtmId: process.env.REACT_APP_GTM,
    });

    return (
        <Suspense fallback={<Loading />}>
            <Provider locale={esEs} value={context}>
                <BrowserRouter>
                    {context.loadingProcedure && (<LoadingProcedure />)}
                    <Page>
                        <Header />
                        {!NOT_FOUND_404_ACTIVE && !context.showFinalMessage.visible && (
                            <Subheader />
                        )}
                        {context.showFinalMessage.visibleError ? <ValidationError /> :
                            <div className='container-ppal'>
                                <Switch>
                                    <Route exact path={`/${context.product}/:token?`} component={Quotation} />
                                    <Route>
                                        <NotFound />
                                    </Route>
                                </Switch>
                            </div>}
                        <Footer />
                    </Page>
                </BrowserRouter>
            </Provider>
        </Suspense>
    )
}